import { propOr } from 'ramda';
import { createSelector } from 'reselect';
import loadingSelector from './loadingSelector';

export default function submitPendingFeedbackFlagSelector(state: any) {
  return createSelector(loadingSelector, propOr(0, 'submitPendingFeedbackFlag'))(state);
}
